
import React, { Component } from 'react';
import Cookies from 'universal-cookie';
import './css/Login.css';
import './js/Login';
import NewsViewer from '../../components/Login/NewsViewer';
//import Monitor from '../Monitor/Monitor';
import history from '../../../../../src/history';
import { checkStatus, getMainCookie } from '../../../util/util'
import {
    BrowserRouter as Router,
    Route,
    Link,
    Redirect,
    withRouter,
    BrowserRouter,
    Switch
} from 'react-router-dom'
const $ = window.$;

const cookies = new Cookies();
class Login extends Component {
    constructor() {
        super();
        this.state = {
            redirectToReferrer: false,
            isShowNews: false
        }
    }

    componentDidMount() {
        console.log("componentDidMount");
        let c = getMainCookie(true);
        if(c.remember){
            this.user_login.value = c.login_name;
            this.user_pass.value =  c.password;
            $('#chkRemember').prop('checked', true);
        }else{
            this.user_login.value = "";
            this.user_pass.value =  "";
            $('#chkRemember').prop('checked', false);
        }
    }
    componentWillFocus() {
        console.log("componentWillFocus");
    }
    componentWillUnmount() {
    }
    componentDidUpdate(){
        // this.setState({isShowNews: true})
    }

    login() {
        console.log("login");
        let currentComponent = this;
        this.dvLoginAlert.innerHTML = "";
        if (this.user_login.value.trim().toString() === "" || this.user_pass.value.trim().toString() === "") {
            this.dvLoginAlert.innerHTML = "กรุณาใส่ชื่อผู้ใช้และรหัสผ่าน";
            this.user_login.focus();
            return;
        }
        fetch("http://203.150.199.244/api/admin/login", {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
            },
            body: JSON.stringify(
                {
                    "userLogin": this.user_login.value,
                    "password": this.user_pass.value
                }
            )
        }).then(function (response) {
            return response.json();
        }).then(function (data) {
            if (data.RESULT_STATUS === "000") {
                data.RESULT_DATA[0].devices = []; 
                data.RESULT_DATA[0].remember = $('#chkRemember').is(":checked"); 
                console.log("xxx",data)
                cookies.set('ft', JSON.stringify(data.RESULT_DATA[0]), { path: '/', maxAge: 24 * 60 * 60 * 1000 });
                currentComponent.setState(() => ({
                    redirectToReferrer: true,
                    user_level: data.RESULT_DATA[0].user_level
                }))
            } else {
                currentComponent.dvLoginAlert.innerHTML = "รหัสผ่านไม่ถูกต้อง";
                currentComponent.user_login.value = "";
                currentComponent.user_pass.value = "";
                currentComponent.user_login.focus();
            }

        });
    }
    onPasswordKeyPress(e) {
        if (e.key === 'Enter') {
            this.login();
        }
    }
    onTxtLoginUnfocus() {
        this.dvLoginAlert.innerHTML = "";
    }

    showNews() {
        console.log('showNews');
        this.setState({
            isShowNews: true
        })
    }

    myFunction() {
        let x = document.getElementById("myInput");
        if (x.type === "password") {
          x.type = "text";
        } else {
          x.type = "password";
        }
    }

    handleNewsDataLoaded(data){
        if(data.length >0 )
            $('#myModal').modal('show');
    }

    render() {
        const { redirectToReferrer, user_level, isShowNews } = this.state

        if (redirectToReferrer === true) {
            if (user_level != 0 && user_level != 1 && user_level != 2)
                return (<Redirect to='/monitor' />);
            return (<Redirect to='/main' />);
        }
        console.log("login")
        return (
            <div className = "login-1">

                <div className="wrapper-login">
                    <div className="logo"><img src="images/logo-fasttrack.png" alt="fasttrack" /></div>
                    <form action="/action_page.php">
                        <div className="container">
                            <div className="input-container">
                                <i className="fa fa-user icon" />
                                <input className="input-style textbox" type="text" autoComplete="off"
                                    ref={(input) => { this.user_login = input; }} onBlur={this.onTxtLoginUnfocus.bind(this)} placeholder="Username"  onBlur={this.onTxtLoginUnfocus.bind(this)} />
                            </div>
                            <div className="input-container">
                                <i className="fa fa-lock icon" />
                                <input className="input-style textbox" type="password" id="myInput" ref={(input) => { this.user_pass = input; }} placeholder="Password" 
                                 onKeyPress={this.onPasswordKeyPress.bind(this)} autoComplete="off"/>
                            </div>
                            <div className = "row">
                                <label className="label-style col-6" style = {{paddingLeft: 0}}>
                                    <input type="checkbox" className = "chk" id = "chkRemember"/> Remember me
                                </label>
                                <label className="label-style col-6" style = {{paddingRight: 0}}>
                                    <span className="psw">
                                        <input type="checkbox" className = "chk" onClick= {this.myFunction.bind(this)} />Show Password</span>
                                </label>
                            </div>
                            
                            
                            <div  className='textAlert' style ={{color: "#fff"}} ref={(div) => { this.dvLoginAlert = div; }}></div>
                            <button className="btn-login" type="button"  ref={(input) => { this.btnLogin = input; }}  onClick={this.login.bind(this)}>LOGIN</button>
                            <div className="footer"><a href="#">Forgot password?</a></div>
                        </div>
                    </form>
                </div>
                <div className="container-xxx">
                    {/* Trigger the modal with a button */}
                    {/* <button type="button" style={{ background: 'none', border: 'none' }} className="btn btn-info btn-lg" data-toggle="modal" data-target="#myModal">Open Modal</button> */}
                    {/* Modal */}
                    <div className="modal fade" id="myModal" role="dialog">
                        <div className="modal-dialog">
                            {/* Modal content*/}
                            <div className="modal-content">

                                <div className="modal-header" style ={{paddingBottom: 0}}>
                                    <h4 className="modal-title " style ={{width : "100%"}} >FASTTRACK GPS</h4>
                                    <button  type="button" className="close"  style={{padding:0,margin:0,fontSize:16,color:"#949494"}} data-dismiss="modal" aria-hidden="true"><span className="fa fa-times" aria-hidden="true" /></button>
                                </div>
                                <div className="modal-body" style ={{paddingTop: 0}}>
                                    <hr></hr>
                                    <div style ={{maxHeight:300 ,overflowY:"auto"}}>
                                        <NewsViewer onDataLoaded = {this.handleNewsDataLoaded.bind(this)}/>
                                    </div>
                                    
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-close" style={{padding:5,margin:0}} data-dismiss="modal">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}
export default Login;


// WEBPACK FOOTER //
// ./src/app/view/containers/Login/Login.js